import { isValidURL } from '@utils/URL/isValidURL';

export const buildPlaylistUrl: (playlistUrl: string) => string = (playlistUrl) => {
  if (isValidURL(playlistUrl)) {
    return playlistUrl;
  }

  const parsedCurrentUrl: URL = new URL(document.location.href);

  if (playlistUrl.startsWith('/')) {
    return `${parsedCurrentUrl.origin}${playlistUrl}`;
  }

  const pathParts: string[] = parsedCurrentUrl.pathname.split('/').filter((pathPart) => pathPart.trim().length > 0);
  // Removes last path part (or two if last part is empty and URL has a trailing slash
  pathParts.pop() || pathParts.pop();

  return `${parsedCurrentUrl.origin}/${pathParts.concat(playlistUrl).join('/')}`;
};
